import { render, staticRenderFns } from "./CertificadoTemplateModal.vue?vue&type=template&id=5de4f752&scoped=true"
import script from "./CertificadoTemplateModal.vue?vue&type=script&lang=js"
export * from "./CertificadoTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CertificadoTemplateModal.vue?vue&type=style&index=0&id=5de4f752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4f752",
  null
  
)

export default component.exports